import skistarImportStatus from '../../../../variables/skistarImportStatus';
import skistarImageStatus from '../../../../variables/skistarImageStatus';

const getDefaultState = () => ({
  resorts: {
    items: [],
    itemsLoading: false,
    itemsError: undefined,
    resort: undefined,
    webservice: null,
    webservices: [],
    subarea: {
      items: [],
      itemsLoading: false,
      itemsError: undefined,
      selected: undefined,
    },
  },
  pagination: {
    offset: 0,
    limit: 300,
    hasMore: true,
  },
  accommodations: {
    items: [],
    itemsLoading: false,
    itemsError: undefined,
    search: undefined,
    subareas: [],
    subarea: undefined,
    categories: {
      items: [],
      itemsLoading: false,
      itemsError: undefined,
      category: undefined,
    },
    selected: [],
    unmap: undefined,
    unmapLoading: false,
    filterImportStatus: skistarImportStatus.ALL,
    filterImageStatus: skistarImageStatus.ALL,
  },
  suppliers: {
    items: [],
    itemsLoading: false,
    itemsError: undefined,
    supplier: undefined,
  },
  sites: {
    items: [],
    itemsLoading: false,
    itemsError: undefined,
    site: undefined,
  },
  import: {
    loading: false,
    error: undefined,
    status: {
      items: [],
      itemsLoading: false,
      itemsError: undefined,
    },
  },
  accommodation: {
    selected: undefined,
    texts: {
      items: [],
      itemsLoading: false,
      itemsError: undefined,
      show: false,
    },
    images: {
      items: {},
      itemsLoading: false,
      itemsError: undefined,
      show: false,
    },
    importStatus: {
      importedAccommodation: undefined,
      loading: false,
      show: false,
      error: undefined,
      updateInProgress: false,
    },
  },
  addons: {
    items: [],
    itemsLoading: false,
    itemsError: undefined,
    updateInProgressItems: {},
    updateErrorItems: {},
    search: undefined,
    addon: {
      showAccommodations: false,
      id: undefined,
      description: undefined,
      accommodations: undefined,
    },
    subarea: {
      items: [],
      itemsLoading: false,
      itemsError: undefined,
      selected: undefined,
    },
  },
});

export default getDefaultState;



// WEBPACK FOOTER //
// ./src/store/modules/ski/skistar/defaultState.js